<template>
  <div class="container">
    <form class="form-horizontal">
      <div class="page-header"><span class="glyphicon glyphicon-paperclip"></span>二级页面轮播图 <button type="button" class="btn btn-success btn-xs" @click="images.push({
        title: '',
        pic: '',
        href: ''
      })">添加</button></div>
      <div class="form-group d-flex" v-d-sortable="images">
        <div class="col-xs-6" v-for="item in images" track-by="$index">
          <div><button type="button" class="close" @click="images.$remove(item)">&times;</button></div>
          <div class="media l-media">
            <div class="media-left l-media-left">
              <d-upload :url.sync="item.pic" class="btn btn-primary btn-block btn-xs">上传图片 1920*700</d-upload>
              <img class="img-responsive" v-show="item.pic" :src="item.pic" alt="">
            </div>
            <div class="media-body">
              <input type="url" class="form-control"  v-model="item.href" placeholder="链接地址"><br>
              <textarea id="" cols="30" rows="5" class="form-control" v-model="item.title" placeholder="介绍"></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group">
        <div class="col-xs-12 text-center">
          <button type="button" class="btn btn-primary" @click="click(submit)($event)">保存</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import dUpload from '../../components/Upload'
  import config from '../../libs/config'
  import utils from '../../libs/utils'

  export default {
    data () {
      return {
        images: []
      }
    },
    components: {
      dUpload
    },
    methods: {
      getSlider () {
        let params = {
          parentId: 0
        }

        return this.$http.get(config.apiWe + '/product/slider', params)
          .then(({data}) => {
            data.length && this.$set('images', data[0].images)
          })
      },
      submit () {
        let data = {
          parentId: 0,
          sliders: [
            {
              type: 'list',
              status: 'hidden',
              location: 'top',
              images: this.images
            }
          ]
        }
        return this.$http.put(config.apiWe + '/product/slider/0', data)
      },
      click: utils.click
    },
    route: {
      data () {
        return this.getSlider()
      }
    }
  }
</script>



/** WEBPACK FOOTER **
 ** Carousel.vue?bd217f46
 **/